<form nz-form class="address-form mr-2" autocomplete="off">
	<div class="title-30 color-blue">
		{{ "global.org_settings.users.title" | translate }}
	</div>
	<div class="subtitle-30 color-grey">
		{{ "global.org_settings.users.subtitle" | translate }}
	</div>
	<nz-input-group [nzAddOnAfter]="suffixIconButton" nzSize="large" class="table-searchbox">
		<input placeholder="input here" nz-input (change)="onChange($event.target.value)"/>
		<ng-template nzSize="medium" #suffixIconButton>
			<button nz-button class="transparent" nzSearch>
				<i nz-icon nzType="search" nzTheme="outline"></i>
			</button>
		</ng-template>
	</nz-input-group>
	<div class="table-modification float-right mb-1">
		<button nz-button class="add-button border-radius-5 color-blue border-color-blue" [nzType]="'Primary'"
			(click)="showInviteModal()">
			<i nz-icon nzType="plus" nzTheme="outline"></i>Invite
		</button>
		<button nz-button class="btn-danger border-radius-5" [nzType]="'Danger'" (click)="deleteAllSelectedUsers()">
			<i nz-icon nzType="delete" nzTheme="outline"></i>Delete
		</button>
	</div>
	<nz-table #rowSelectionTable nzShowSizeChanger [nzData]="listOfData"
		(nzCurrentPageDataChange)="onCurrentPageDataChange($event)" [nzShowPagination]="false">
		<thead>
			<tr>
				<th [nzWidth]="columnWidth" [(nzChecked)]="checked" [nzIndeterminate]="indeterminate"
					(nzCheckedChange)="onAllChecked($event)">
				</th>
				<th *ngFor="let column of listOfColumn" [nzSortOrder]="column.sortOrder" [nzSortFn]="column.sortFn"
					[nzSortDirections]="column.sortDirections" [nzWidth]="column?.width">
					{{ column.title }}
				</th>
			</tr>
		</thead>
		<tbody>
			<tr *ngFor="let data of rowSelectionTable.data">
				<td [nzChecked]="setOfCheckedId.has(data.id)" (nzCheckedChange)="onItemChecked(data.id, $event)"></td>
				<td>{{ data.name }}</td>
				<td>{{ data.status }}</td>
				<td class="grey-border-1">
					<nz-select [ngModel]="selectedValue" [nzServerSearch]="true" class="full-width" nzSize="large"
						name="owner" (ngModelChange)="valueSelected(data, $event)">
						<nz-option *ngFor="let option of listOfOptions" [nzLabel]="option.role" [nzValue]="option.role">
						</nz-option>
					</nz-select>
				</td>
			</tr>
		</tbody>
	</nz-table>
</form>
<nz-modal [(nzVisible)]="inviteModalVisible" (nzOnCancel)="handleCancel(inviteUserForm)"
	(nzOnOk)="handleOk(inviteUserForm)" [nzTitle]="modalTitle" nzCentered [nzStyle]="inviteModalStyle">
	<ng-template #modalTitle class="font-800">
		Invite new user via E-mail
	</ng-template>
	<ng-container *nzModalContent>
		<div class="center">
			<form [formGroup]="inviteUserForm" class="invite-form">
				<nz-form-item class="input-field title-14">
					<nz-form-control>
						<app-input-field [size]="'large'" [form]="inviteUserForm" [label]="'User E-mail'"
							placeholder="Enter the e-mail to send invitation" [formName]="'email'">
						</app-input-field>
					</nz-form-control>
				</nz-form-item>
				<nz-form-item class="input-field title-14">
					<nz-form-control class="full-width">
						<nz-input-group class="icons custom-select pt-0 pb-0">
							<nz-select nzPlaceHolder="Select Role" [(ngModel)]="SelectedRole" formControlName="role"
								[nzSize]="'large'">
								<nz-option *ngFor="let option of listOfOption" [nzLabel]="option.label"
									[nzValue]="option.value">
								</nz-option>
							</nz-select>
						</nz-input-group>
					</nz-form-control>
				</nz-form-item>
			</form>
		</div>
	</ng-container>
	<div *nzModalFooter>
		<button nz-button nzType="default" class="color-grey border-none"
			(click)="handleCancel(inviteUserForm)">Back</button>
		<button nz-button [disabled]="inviteUserForm.invalid" nzType="default" class="border-radius-5 border-color-blue color-blue"
			(click)="handleOk(inviteUserForm)">Invite</button>
	</div>
</nz-modal>
